import React, { useState } from "react";
import PropTypes from "prop-types";

import _ from "lodash";
import Spinner from "../Spinner/Spinner.jsx";

import "./styles/style.scss";

const Button = ({ isSubmit, isStretch, color, size, paddingOff, icon, ...rest }) => {
  const [isFetchData, setIsFetchData] = useState(false);

  /**
   * Вернуть класс, применяемый для цвета фона кнопки
   *
   * @param {String} value
   * @return {String}
   */
  const getColorClass = value => {
    const classes = {
      primary: "button--primary",
      secondary: "button--secondary",
      outline: "button--secondary-outline",
      success: "button--notify-success",
      warn: "button--notify-warn",
      error: "button--notify-error",
      alertSuccess: "button--alert-success",
      alertWarn: "button--alert-warn",
      alertError: "button--alert-error",
    };

    return _.get(classes, value, Button.defaultProps.color);
  };

  /**
   * Вернуть класс, применяемый для размера кнопки
   *
   * @param {String} value
   * @return {String}
   */
  const getSizeClass = value => {
    const classes = {
      xxl: "button--xxl",
      xl: "button--xl",
      lg: "button--lg",
      md: "button--md",
      sm: "button--sm",
      xs: "button--xs",
    };

    return _.get(classes, value, Button.defaultProps.size);
  };

  /**
   * Вернуть класс, применяемый для удаления внутреннего отступа с определенной стороны
   *
   * @param {String} value
   * @return {String}
   */
  const getPaddingClass = value => {
    const classes = {
      all: "button--padding0",
      lr: "button--padding-lr0",
      tb: "button--padding-tb0",
    };

    return _.get(classes, value, Button.defaultProps.paddingOff);
  };

  /**
   * Вернуть класс, применяемый для отображения кнопки с иконкой
   *
   * @param {String} value
   * @return {String}
   */
  const getIconClass = value => {
    const classes = {
      only: "button--icon",
      left: "button--icon-left",
      right: "button--icon-right",
    };

    return _.get(classes, value, Button.defaultProps.icon);
  };

  const handleClick = async event => {
    const rootElement = document.getElementById("app");
    rootElement.classList.add("app--not-available");

    setIsFetchData(true);
    await rest.onClick(event);

    rootElement.classList.remove("app--not-available");
    setIsFetchData(false);
  };

  const classNames = [
    "button",
    isStretch && "button--stretch",
    getColorClass(color),
    getSizeClass(size),
    getPaddingClass(paddingOff),
    getIconClass(icon),
    rest.disabled && "button--disabled",
    rest.className,
  ]
    .filter(name => name)
    .join(" ");

  return (
    <button
      {...rest}
      type={isSubmit ? "submit" : "button"}
      onClick={rest.onClick ? handleClick : f => f}
      className={classNames}
    >
      <div className="button-title" style={{ opacity: +!isFetchData }}>
        {rest.children}
      </div>
      <div className="button-spinner">{isFetchData && <Spinner />}</div>
    </button>
  );
};

Button.propTypes = {
  isSubmit: PropTypes.bool,
  isStretch: PropTypes.bool,
  color: PropTypes.string,
  size: PropTypes.string,
  paddingOff: PropTypes.string,
  icon: PropTypes.string,
};

Button.defaultProps = {
  isSubmit: false,
  isStretch: false,
  color: "",
  size: "xl",
  paddingOff: "",
  icon: "",
};

export default Button;
